




































import {Getter} from "vuex-class";
import {Component, Vue} from 'vue-property-decorator'
import {getOrderRemarkList, RemarkListDTO} from '@/api/order'

Component.registerHooks(['beforeRouteLeave']);

@Component({
    name: 'Remarks'
})
export default class Remarks extends Vue {
    @Getter companyId!: string

    params = {
        companyId: '',
        currRouteId: '',
        orderId: '',
        orderType: '' // 1:订货单 2:退货单
    }
    remarkList: RemarkListDTO[] = []

    activated() {
        if (this.$route.query.isRefresh) {
            this.getOrderRemarkList()
        }
    }

    beforeRouteLeave(to, from, next) {
        if (to.path.toLowerCase() === '/orderDetail'.toLowerCase() || to.path.toLowerCase() === '/orderReturnDetail'.toLowerCase()) {
            to.query.fromPath = '1'
        }
        next();
    }

    created() {
        this.params.companyId = this.companyId
        this.params.orderId = this.$route.query.orderId as string
        this.params.currRouteId = this.$route.query.currRouteId as string
        this.params.orderType = this.$route.query.orderType as string
        // 获取备注页数据
        this.getOrderRemarkList()
    }

    /**
     * @description: 获取备注页数据
     * @param {*}
     * @return {*}
     */
    getOrderRemarkList() {
        getOrderRemarkList(this.params).then(res => {
            this.remarkList = (res.data && res.data.orderRemark) || []
        })
    }

    /* 添加备注 */
    addRemark() {
        this.$router.push({
            path: '/addRemark',
            query: {
                orderId: this.params.orderId,
                orderType: this.params.orderType,
                currRouteId: this.params.currRouteId
            }
        })
    }

}
